import type { TranslationMessages } from '../types';

export const campaigns: TranslationMessages = {
      title: 'Chiến dịch',
      subtitle: 'Quản lý và theo dõi các chiến dịch kinh doanh của bạn',
      new_campaign: 'Chiến dịch mới',
      edit_campaign: 'Chỉnh sửa chiến dịch',
      create_campaign: 'Tạo chiến dịch',
      update_campaign: 'Cập nhật chiến dịch',
      campaign_details: 'Chi tiết chiến dịch',
      loading: 'Đang tải chiến dịch...',
      loading_campaign: 'Đang tải chiến dịch...',
      no_campaigns: 'Chưa có chiến dịch nào. Tạo chiến dịch đầu tiên của bạn!',
      no_results: 'Không tìm thấy chiến dịch nào phù hợp với tìm kiếm của bạn.',
      search_placeholder: 'Tìm kiếm chiến dịch...',
      delete_confirm: 'Bạn có chắc chắn muốn xóa chiến dịch này không?',
      delete_error: 'Không thể xóa chiến dịch',
      load_error: 'Không thể tải chiến dịch',
      save_error: 'Không thể lưu chiến dịch',
      name: 'Tên chiến dịch',
      name_required: 'Tên chiến dịch *',
      name_placeholder: 'Ví dụ: Chiến dịch Pivot Trà sữa 90 ngày',
      description: 'Mô tả',
      description_placeholder:
        'Mô tả mục tiêu và chiến lược chiến dịch của bạn...',
      start_date: 'Ngày bắt đầu',
      start_date_required: 'Ngày bắt đầu *',
      end_date: 'Ngày kết thúc',
      end_date_required: 'Ngày kết thúc *',
      target_revenue: 'Doanh thu mục tiêu (VND)',
      target_category_revenue: 'Doanh thu danh mục mục tiêu (VND)',
      active: 'Chiến dịch đang hoạt động',
      saving: 'Đang lưu...',
      create_subtitle: 'Tạo chiến dịch mới để theo dõi hiệu suất',
      update_subtitle: 'Cập nhật chi tiết chiến dịch',
      status: {
        active: 'Đang hoạt động',
        inactive: 'Không hoạt động',
        upcoming: 'Sắp tới',
        ended: 'Đã kết thúc',
      },
      actions: {
        report: 'Báo cáo',
        edit: 'Sửa',
        delete: 'Xóa',
      },
      fields: {
        target: 'Mục tiêu',
      },
      select_categories: 'Chọn danh mục sản phẩm',
      select_categories_description:
        'Giới hạn chiến dịch này cho các danh mục sản phẩm cụ thể. Để trống để bao gồm tất cả danh mục.',
      search_categories: 'Tìm kiếm danh mục...',
      loading_categories: 'Đang tải danh mục...',
      no_categories: 'Không tìm thấy danh mục',
      select_products: 'Chọn sản phẩm',
      select_products_description:
        'Giới hạn chiến dịch này cho các sản phẩm cụ thể. Để trống để bao gồm tất cả sản phẩm.',
      search_products: 'Tìm kiếm sản phẩm...',
      loading_products: 'Đang tải sản phẩm...',
      no_products: 'Không tìm thấy sản phẩm',
    };
